import React, { useRef } from 'react'

import { useTrackResetClick } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearAllFilters } from 'Pods/SearchPage/Store/actions'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import { getFiltersCount } from 'Pods/SearchPage/Store/selectors'

function ClearFiltersButton() {
  const translate = useTranslate()
  const filtersCount = useSearchPageStore(state => getFiltersCount(state))
  const wrapperRef = useRef(null)
  const trackResetClick = useTrackResetClick()

  const handleClear = (event) => {
    // Clearing unmounts this button, which would drop keyboard focus to <body>; hand it to the
    // More Filters trigger right before it instead.
    if (document.activeElement === event.currentTarget) {
      // Below md the More Filters trigger is itself the <button> sibling, not a wrapper around one.
      const trigger = wrapperRef.current?.previousElementSibling
      ;(trigger?.matches('button') ? trigger : trigger?.querySelector('[role="button"]'))?.focus()
    }
    trackResetClick()
    clearAllFilters()
  }

  if (filtersCount === 0) return null

  return (
    <div ref={wrapperRef} className="main-filters__clear">
      <button
        type="button"
        className="main-filters__clear-button cgt-link-secondary"
        onClick={handleClear}
      >
        {/* Figma 415:23304 shortens the label at md so the row fits; CSS picks the visible one. */}
        <span className="main-filters__clear-label">{translate('search_page.filters.clear_all')}</span>
        <span className="main-filters__clear-label main-filters__clear-label--short">
          {translate('search_page.filters.clear_all_short', { count: filtersCount })}
        </span>
      </button>
    </div>
  )
}

export default ClearFiltersButton
